export default {
    styleOverrides: {
        root: {}
    }
}
